// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var unsafePlaceholder = {};

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = React.lazy(function (param) {
      return import("./ThreeBoxUpdate.bs.js");
    });

var UnsafePlaceholder = unsafePlaceholder;

export {
  unsafePlaceholder ,
  UnsafePlaceholder ,
  makeProps ,
  make ,
  
}
/* make Not a pure module */
